(function () {
  'use strict';

  // The old affordance ran a requestAnimationFrame loop writing scrollLeft every frame for 600ms,
  // starting a fixed 300ms after DOMContentLoaded — squarely inside the LCP window, on the page
  // whose whole point is the product photo. Native scrollTo({behavior:'smooth'}) animates off the
  // main thread; requestIdleCallback waits for the browser to settle instead of guessing a delay.
  var NUDGE_PX = 32;

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var root = document.querySelector('[data-main-product]');
    if (!root) return;

    var track = root.querySelector('[data-gallery-track]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-gallery-slide]');
    if (slides.length < 2) return;

    // Mobile only — desktop uses grid layout, no swipe gallery
    if (window.innerWidth >= 1024) return;

    // The idle callback can land up to 2s late, by which point the shopper may have swiped
    // themselves — nudging then yanks them back to slide 1 with snap disabled.
    var cancelled = false;
    function cancel() { cancelled = true; }
    track.addEventListener('pointerdown', cancel, { once: true, passive: true });
    track.addEventListener('touchstart', cancel, { once: true, passive: true });

    // Whichever of scrollend / the timeout lands first wins and tears the other down: scrollend
    // isn't universal (Safari < 17.4), and a timeout that fired while the listener stayed attached
    // would re-run the next leg on the following genuine scrollend.
    function afterScroll(fn) {
      var done = false;
      var timer = setTimeout(run, 400);
      track.addEventListener('scrollend', run);
      function run() {
        if (done) return;
        done = true;
        clearTimeout(timer);
        track.removeEventListener('scrollend', run);
        fn();
      }
    }

    function nudge() {
      if (cancelled || track.scrollLeft !== 0) return;

      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';

      track.scrollTo({ left: NUDGE_PX, behavior: 'smooth' });
      afterScroll(function () {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        afterScroll(function () { track.style.scrollSnapType = prevSnap; });
      });
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(nudge, { timeout: 2000 });
    } else {
      setTimeout(nudge, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
